import React from "react";
import PropTypes from "prop-types";

const maxHeight = 100;
let maxCylinder;
let totalCount;

let colors = ["blue", "green", "orange", "red", "darkblue", "marsala", "darkgreen", "magenta", "hotpink", "caribbeangreen", "strongorange", "darkcyan"];

export default class DomoFunnel extends React.PureComponent {
  componentDidMount() {
    this.CreateChart();
  }

  totalOffers(data) {
    let offersTotal = 0;
    data[1].map(item => {
      offersTotal = offersTotal + item[0];
    });
    return offersTotal;
  }

  convertToAny(data, index) {
    let offersTotal = 0;
    let total = 0;
    data[index].map(item => {
      total = total + item[0];
    });
    data[1].map(item => {
      offersTotal = offersTotal + item[0];
    });
    return `${total} of ${offersTotal} (${isNaN(Math.floor((total / offersTotal) * 100)) ? 0 : Math.floor((total / offersTotal) * 100)}%)`;
  }

  CreateChart() {
    totalCount = 0;
    $("#mroichart").empty();
    this.CountTotal();

    for (let r = 0; r < this.props.dataArray.length; r++) {
      let parDiv = document.createElement("div");
      $(parDiv).addClass("chartsection");

      for (let c = 0; c < this.props.dataArray[r].length; c++) {
        let childDiv = document.createElement("div");
        let childDiv2 = document.createElement("div");
        let ul = document.createElement("ul");
        let span1;

        let h5 =
          '<h5 data-toggle="tooltip" data-placement="top" ' + "title=" + '"' + this.props.dataArray[r][c] + '"' + ">" + this.props.dataArray[r][c] + "</h5>";

        if (r === 0) {
          $(parDiv).append(childDiv);
          $(childDiv2).addClass("elltooltip");
          $(childDiv2).attr("data-url", this.props.dataArray[r + 1][c][2]);
          $(childDiv2).append(h5);
        } else if (r !== 0 && r !== this.props.dataArray.length - 1) {
          $(parDiv).addClass("sec s" + r);
          $(childDiv2).addClass("rectslice");
          $(childDiv2).attr("data-url", this.props.dataArray[r][c][2]);
          let elwidth = (this.props.dataArray[r][c][0] / totalCount) * this.props.chartWidth;
          $(childDiv2).css({ width: elwidth });

          if (r === 2 || r === 3) {
            if (elwidth > 20) {
              span1 =
                '<span data-toggle="tooltip" data-placement="top" ' +
                "title=" +
                '"' +
                this.props.dataArray[r][c][1] +
                '"' +
                ">" +
                this.props.dataArray[r][c][0] +
                "</span>";
            } else {
              span1 =
                '<span class="hide-number" data-toggle="tooltip" data-placement="top" ' +
                "title=" +
                '"' +
                this.props.dataArray[r][c][1] +
                '"' +
                ">" +
                this.props.dataArray[r][c][0] +
                "</span>";
            }
          } else {
            span1 =
              `<span class=${elwidth > 22 ? "count" : "hide-number"} data-toggle="tooltip" data-html="true" data-placement="top" ` +
              "title=" +
              '"' +
              this.props.dataArray[r][c][1] +
              '"' +
              ">" +
              this.props.dataArray[r][c][0] +
              "</span>";
          }
          $(childDiv2).append(span1);
        } else {
          $(childDiv2).addClass("cillindreslice");
          $(childDiv2).attr("data-url", this.props.dataArray[4][c][4]);
          let elheight = Math.round((this.props.dataArray[r][c][0] / maxCylinder) * maxHeight);
          $(childDiv2).css({ height: elheight });
          childDiv2.append(ul);
          $(ul).css({ height: elheight });
          
          let spanServices =
            '<span data-toggle="tooltip" data-placement="top" ' + "title=" + '"Service Revenue: ' + this.props.dataArray[4][c][2] + '">' + "</span>";

          let spanProducts =
            '<span data-toggle="tooltip" data-placement="top" ' + "title=" + '"Product Revenue: ' + this.props.dataArray[4][c][3] + '">' + "</span>";

          let color1 = colors[c];

          $(ul).append(
            '<li class="service-bar ' +
            color1 +
            '"' +
            ' style="opacity:0.9;' +
            '"' +
            ">" +
            spanServices +
            "</li>" +
            '<li class="product-bar ' +
            color1 +
            '"' +
            ' style="opacity:0.5;' +
            '"' +
            ">" +
            spanProducts +
            "</li>"
          );
        }
        $(childDiv2).addClass(colors[c]);
        parDiv.append(childDiv2);

        if (r === 1 && c === this.props.dataArray[r].length - 1) {
          $('<svg id="topsvg" width="100%" height="20px"></svg>').appendTo("#mroichart");
        }
        if (r === this.props.dataArray.length - 1 && c === this.props.dataArray[r].length - 1) {
          $('<svg id="bottomsvg" width="100%" height="20px"> </svg>').appendTo(parDiv);
        }
      }

      $("#mroichart").append(parDiv);
      $('[data-toggle="tooltip"]').tooltip({ trigger: "hover" });
    }

    $("div.elltooltip")
      .off("click")
      .on("click", function (event) {
        event.preventDefault();
        window.open($(this).attr("data-url"), "_raw_data_tab");
      });

    $("div.rectslice")
      .off("click")
      .on("click", function (event) {
        event.preventDefault();
        window.open($(this).attr("data-url"), "_raw_data_tab");
      });

    $("div.cillindreslice")
      .off("click")
      .on("click", function (event) {
        event.preventDefault();
        window.open($(this).attr("data-url"), "_raw_data_tab");
      });

    $("div.box-funnel-chart")
      .off("click")
      .on("click", function (event) {
        event.preventDefault();
        window.open($(this).attr("data-url"), "_raw_data_tab");
      });

    this.CountShadows();
  }
  CountTotal() {
    for (var i = 0; i < this.props.dataArray[1].length; i++) {
      totalCount += this.props.dataArray[1][i][0];
    }
    let cilldenValues = [];
    for (var k = 0; k < this.props.dataArray[this.props.dataArray.length - 1].length; k++) {
      cilldenValues[k] = this.props.dataArray[this.props.dataArray.length - 1][k][0];
    }

    maxCylinder = Math.max.apply(Math, cilldenValues);
  }

  CountShadows() {
    let css = "<style>";
    for (var i = 1; i < 3; i++) {
      let bWidth = ($(".s" + [i]).width() - $(".s" + [i + 1]).width()) / 2;

      css += ".s" + i + ":after{border-left-width: " + bWidth + "px; border-right-width:" + bWidth + "px; }";
    }

    css += "</style>";
    $("head").append(css);

    this.CreateTopConnections();
  }

  CreateTopConnections() {
    for (var n = 0; n < this.props.dataArray[0].length; n++) {
      let currEll = $(".elltooltip")[n];
      let currRect = $(".rectslice")[n];

      let offset = (this.props.chartWidth - $($(".chartsection")[0]).width()) / 2;
      var color = $(currEll).css("background-color");

      var x1 = parseInt($(currEll).width() / 2 + $(currEll).position().left + offset);
      var x2 = parseInt($(currRect).width() / 2 + $(currRect).position().left);

      $("#topsvg").css("width", this.props.chartWidth);
      $("#topsvg").append(
        '<svg><path d="M' +
          x1 +
          ",0 C" +
          x1 +
          ",20 " +
          x2 +
          ",0 " +
          x2 +
          ',20" style="stroke:' +
          color +
          '; stroke-width:1; fill:none;" shape-rendering="optimizeQuality"/></svg>'
      );
    }
    this.CreateBottomConnections();
  }

  CreateBottomConnections() {
    for (var n = 0; n < this.props.dataArray[0].length; n++) {
      let currEll = $(".cillindreslice")[n];
      let currRect = $($(".chartsection")[this.props.dataArray.length - 2]).children(".rectslice")[n];

      let offsetRect = ($("#mroichart").width() - $($(".chartsection")[this.props.dataArray.length - 2]).width()) / 2;
      let offsetEll = ($("#mroichart").width() - $($(".chartsection")[this.props.dataArray.length - 1]).width()) / 2;

      let offset = offsetRect - offsetEll;

      var color = $(currEll).css("background-color");

      var x2 = parseInt($(currEll).width() / 2 + $(currEll).position().left);
      var x1 = parseInt($(currRect).width() / 2 + $(currRect).position().left + offset);

      var y2 = $(currEll).position().top;

      $("#bottomsvg").append(
        '<svg><path d="M' +
          x1 +
          ",0 C" +
          x1 +
          "," +
          y2 +
          " " +
          x2 +
          ",0 " +
          x2 +
          "," +
          y2 +
          '" style="stroke:' +
          color +
          '; stroke-width:1.5; fill:none;" shape-rendering="optimizeQuality"/></svg>'
      );
    }
    this.PlaceMetrics();
  }

  PlaceMetrics() {
    for (let i = 0; i < this.props.dataArray.length - 2; i++) {
      const chartLabel = $(".metrics")[i];
      const chartLabelWidth = chartLabel.offsetWidth;
      const chartSection = $(".s" + (i + 1)).width();
      // left and right offsets are the same as content centered
      const chartSectionOffset = $(".s" + (i + 1)).position().left;

      const maxWidthForText = 1270 - chartSection - chartSectionOffset - 15;

      if (chartLabelWidth > maxWidthForText) {
        chartLabel.parentElement.style.width = maxWidthForText + "px";
        chartLabel.parentElement.style.height = "auto";
        $(".iitem2").css("marginTop", "30px");
      }
    }
  }

  render() {
    return (
      <div id="funnel_retention_chart">
        <div className="container-fluid">
          <div className="row">
            <div className="col-xs-9 col-sm-9 col-md-9 col-lg-10">
              <div className="fullcontainer">
                <div className="row text-center">
                  <div id="mroichart" />
                </div>

                <div className="infoside">
                  <div className="offers-sold">
                    <span className="metrics" title="Offers Sold to New Or Existing Clients" data-toggle="tooltip" data-placement="top">
                      {this.props.label ? this.props.label : "Offers"} Sold: {this.totalOffers(this.props.dataArray)}
                    </span>
                  </div>

                  <div className="row">
                    <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                      <div className="iitem">
                        <span className="metrics">Converted to Service: {this.convertToAny(this.props.dataArray, 2)}</span>
                      </div>
                      <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6" />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                      <div className="iitem iitem2">
                        <span className="metrics">Converted to Membership: {this.convertToAny(this.props.dataArray, 3)}</span>
                      </div>
                      <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6" />
                    </div>
                  </div>
                </div>
                <div className="flex-container">
                  <div className="charttotal">
                    {this.props.dataArray[4].map((item, key) => (
                      <div key={key} className={`totalitem ${colors[key]}`}>
                        <h5>{item[1]}</h5>
                        <br />
                        <h6 className="average">Service Sales Total: {item[2]}</h6>
                        <h6 className="average">Product Sales Total: {item[3]}</h6>
                        <br />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

DomoFunnel.propTypes = {
  dataArray: PropTypes.array,
  chartWidth: PropTypes.number,
  label: PropTypes.string
};
